import React, { Component } from 'react'
import { Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap'

class RelatedDocumentsBodyNavMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true
    }
    this.tabs = []
  }

  componentDidMount() {
    let tabs = []
    const relatedDocumentsData = this.props.relatedDocumentsData
    if (relatedDocumentsData) {
      tabs = [...new Set(relatedDocumentsData.map(item => item.year))].sort().reverse() //Se utiliza Set para que no se añadan años repetidos
    }

    this.tabs = tabs
    if (this.state.loading) {
      this.setState({ loading: false })
    }
  }

  renderIfAllOK() {
    const tabs = this.tabs
    let navBuffer = []
    let dropdownBuffer = []
    let renderingComponent

    if (!this.state.loading) {
      for (let i = 0; i < tabs.length; i++) {
        if (i < 2) {
          let navItem = (
            <NavItem eventKey={tabs[i]} key={tabs[i]}>
              {tabs[i]}
            </NavItem>
          )
          navBuffer.push(navItem)
        } else {
          let menuItem = (
            <MenuItem eventKey={tabs[i]} key={tabs[i]}>
              {tabs[i]}
            </MenuItem>
          )
          dropdownBuffer.push(menuItem)
        }
      }
      renderingComponent = (
        <React.Fragment>
          <Nav bsStyle="tabs" className="ork-related-documents__nav-tabs">
            {navBuffer}

            {dropdownBuffer.length > 0 ? (
              <NavDropdown eventKey="dropdown" title="Años anteriores" noCaret>
                {dropdownBuffer}
              </NavDropdown>
            ) : (
              ''
            )}
          </Nav>
        </React.Fragment>
      )
    }

    return renderingComponent
  }

  render() {
    return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
  }
}

export default RelatedDocumentsBodyNavMenu



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsBodyNavMenu/RelatedDocumentsBodyNavMenu.jsx